module.exports = "<p>\n  m works!\n</p>\n"